@let collection = collectionSg();
@let isSubmitting =
  collection.plugins.editingPlugin.feature.selectors.isSubmitting.asSignal();
@let hasDeletions =
  collection.plugins.editingPlugin.feature.selectors.hasDeletions.asSignal();
@let isCreatingResponsiblePerson =
  collection.plugins.currentEntityPlugin.feature.selectors
    .isCreating()
    .asSignal();
@let isCreatingEmployee =
  employeeEc.plugins.currentEntityPlugin.feature.selectors
    .isCreating()
    .asSignal();
@let updatedEntity =
  collection.plugins.currentEntityPlugin.feature.selectors
    .getUpdatedEntity()
    .asSignal();

<div class="atn-space-responsible-persons">
  <!-- TODO: Expose a table-specific collection type/signal and remove $any() cast. -->
  <atn-ds-table [config]="tableConfigSg()" />
</div>

@if (isCreatingResponsiblePerson && !isCreatingEmployee) {
  <atn-space-responsible-persons-modal [collection]="collection" />
}

@if (isCreatingResponsiblePerson && isCreatingEmployee) {
  <atn-space-modal-create-employee-form
    [selectionTarget]="collection.associations?.selectionTarget"
  />
}

@if (updatedEntity) {
  @if (updatedEntity.isPrimary) {
    <atn-ds-confirmation-overlay
      title="Make Responsible Person Primary"
      description="If you save, this person will become primary and the previous
    primary will lose their status. Are you sure you want to proceed?"
      confirmButtonText="Save"
      [confirmButtonStyle]="confirmationOverlayStyle.Info"
      [loading]="isSubmitting"
      (confirm)="updateResponsiblePersonHandler()"
      (cancel)="cancelResponsiblePersonUpdateHandler()"
    />
  } @else {
    <atn-ds-confirmation-overlay
      title="Demote Primary Responsible Person"
      description="This person is currently primary. If you save, they will no
    longer be primary. Are you sure you want to proceed?"
      confirmButtonText="Save"
      [confirmButtonStyle]="confirmationOverlayStyle.Info"
      [loading]="isSubmitting"
      (confirm)="updateResponsiblePersonHandler()"
      (cancel)="cancelResponsiblePersonUpdateHandler()"
    />
  }
}

@if (hasDeletions) {
  <atn-ds-confirmation-overlay
    title="Delete Responsible Person"
    description="Are you sure you want to delete this responsible person?"
    (cancel)="cancelDeletionClickHandler()"
    (confirm)="confirmDeletionClickHandler()"
    confirmButtonText="Delete"
    [loading]="isSubmitting"
  />
}
